import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/images/logo.svg";
import $ from "jquery";
import { tokencheck } from "../helper/jwttoken";
import { getUrlList } from "../Action/UserAction";
import config from "../config/config";
export default function Navbar(props) {
  const [data, setData] = useState([]);
  const [role, setRole] = useState("");
  const [logodata, setLogodata] = useState();
  useEffect(() => {
    loadScript();
  }, []);

  function loadScript() {
    $(document).ready(function () {
      // $(".close_icon, .close_overlay").click(function () {
      $(document).on("click", ".close_icon, .close_overlay", function () {
        console.log("menu close");
        $(".app_sidebar").removeClass("show");
        $("body").removeClass("menu_overlay");
      });
    });
  }
  async function getrestriction() {
    try {
      var admintoken = localStorage.getItem("admin_token");
      var decoded = await tokencheck(admintoken);
      console.log(decoded, "decodedddddddddd");
      setData(decoded.restriction);
      setRole(decoded.role);
    } catch (err) {
      console.log(err, "eeeeeeeeeeee");
    }
  }

  async function getList() {
    var response = await getUrlList();
    var list1 = response && response.result ? response.result : {};
    setLogodata(list1);
    console.log(list1, "logodata");
  }

  useEffect(() => {
    // getList();
    getrestriction();
  }, []);
  return (
    <>
      <div className="app_sidebar">
        <i className="fa-solid fa-xmark close_icon"></i>
        <div className="app_sidebar_logo">
          <Link to="/">
            <img
              src={logo}
              alt="Logo"
              className="img-fluid brand_logo"
            />
          </Link>
        </div>
        <div className="app_sidebar_menu">

          <ul
            className="nav nav-pills flex-column mb-auto sidebar_menu"
            id="sidemenu"
          >
            <li className="nav-item">
              <NavLink to="/dashboard" className="nav-link close_overlay">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="17"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M2.22222 20.5C1.61111 20.5 1.08778 20.2826 0.652222 19.8478C0.217407 19.4122 0 18.8889 0 18.2778V2.72222C0 2.11111 0.217407 1.58778 0.652222 1.15222C1.08778 0.717407 1.61111 0.5 2.22222 0.5H6.66667C7.27778 0.5 7.80111 0.717407 8.23667 1.15222C8.67148 1.58778 8.88889 2.11111 8.88889 2.72222V18.2778C8.88889 18.8889 8.67148 19.4122 8.23667 19.8478C7.80111 20.2826 7.27778 20.5 6.66667 20.5H2.22222ZM13.3333 8.27778C12.7222 8.27778 12.1993 8.06 11.7644 7.62444C11.3289 7.18963 11.1111 6.66667 11.1111 6.05556V2.72222C11.1111 2.11111 11.3289 1.58778 11.7644 1.15222C12.1993 0.717407 12.7222 0.5 13.3333 0.5H17.7778C18.3889 0.5 18.9122 0.717407 19.3478 1.15222C19.7826 1.58778 20 2.11111 20 2.72222V6.05556C20 6.66667 19.7826 7.18963 19.3478 7.62444C18.9122 8.06 18.3889 8.27778 17.7778 8.27778H13.3333ZM13.3333 20.5C12.7222 20.5 12.1993 20.2826 11.7644 19.8478C11.3289 19.4122 11.1111 18.8889 11.1111 18.2778V12.7222C11.1111 12.1111 11.3289 11.5878 11.7644 11.1522C12.1993 10.7174 12.7222 10.5 13.3333 10.5H17.7778C18.3889 10.5 18.9122 10.7174 19.3478 11.1522C19.7826 11.5878 20 12.1111 20 12.7222V18.2778C20 18.8889 19.7826 19.4122 19.3478 19.8478C18.9122 20.2826 18.3889 20.5 17.7778 20.5H13.3333Z"
                    fill="white"
                  />
                </svg>
                Dashboard
              </NavLink>
            </li>

            <li className="nav-item">
              <Link
                className="nav-link btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#settings-collapse"
                aria-expanded="false"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M11.5625 18.8334H8.4375C8.22916 18.8334 8.04861 18.7639 7.89583 18.625C7.74305 18.4861 7.65277 18.3125 7.625 18.1042L7.375 16.1667C7.19444 16.0972 7.02416 16.0139 6.86416 15.9167C6.70416 15.8195 6.54805 15.7153 6.39583 15.6042L4.58333 16.3542C4.38889 16.4236 4.19444 16.4306 4 16.375C3.80555 16.3195 3.65277 16.2014 3.54166 16.0209L2 13.3334C1.88889 13.1528 1.85416 12.9584 1.89583 12.75C1.9375 12.5417 2.04166 12.375 2.20833 12.25L3.77083 11.0625C3.75694 10.9653 3.75 10.8714 3.75 10.7809V10.2192C3.75 10.1286 3.75694 10.0347 3.77083 9.93752L2.20833 8.75002C2.04166 8.62502 1.9375 8.45835 1.89583 8.25002C1.85416 8.04169 1.88889 7.84724 2 7.66669L3.54166 4.97919C3.63889 4.78474 3.78805 4.66308 3.98916 4.61419C4.19027 4.5653 4.38833 4.57585 4.58333 4.64585L6.39583 5.39585C6.54861 5.28474 6.70833 5.18058 6.875 5.08335C7.04166 4.98613 7.20833 4.9028 7.375 4.83335L7.625 2.89585C7.65277 2.68752 7.74305 2.51391 7.89583 2.37502C8.04861 2.23613 8.22916 2.16669 8.4375 2.16669H11.5625C11.7708 2.16669 11.9514 2.23613 12.1042 2.37502C12.2569 2.51391 12.3472 2.68752 12.375 2.89585L12.625 4.83335C12.8056 4.9028 12.9758 4.98613 13.1358 5.08335C13.2958 5.18058 13.4519 5.28474 13.6042 5.39585L15.4167 4.64585C15.6111 4.57641 15.8056 4.56946 16 4.62502C16.1944 4.68058 16.3472 4.79863 16.4583 4.97919L18 7.66669C18.1111 7.84724 18.1458 8.04169 18.1042 8.25002C18.0625 8.45835 17.9583 8.62502 17.7917 8.75002L16.2292 9.93752C16.2431 10.0347 16.25 10.1286 16.25 10.2192V10.7809C16.25 10.8714 16.2361 10.9653 16.2083 11.0625L17.7708 12.25C17.9375 12.375 18.0417 12.5417 18.0833 12.75C18.125 12.9584 18.0903 13.1528 17.9792 13.3334L16.4375 16C16.3264 16.1806 16.17 16.3022 15.9683 16.365C15.7667 16.4278 15.5689 16.4242 15.375 16.3542L13.6042 15.6042C13.4514 15.7153 13.2917 15.8195 13.125 15.9167C12.9583 16.0139 12.7917 16.0972 12.625 16.1667L12.375 18.1042C12.3472 18.3125 12.2569 18.4861 12.1042 18.625C11.9514 18.7639 11.7708 18.8334 11.5625 18.8334ZM10.0417 13.4167C10.8472 13.4167 11.5347 13.132 12.1042 12.5625C12.6736 11.9931 12.9583 11.3056 12.9583 10.5C12.9583 9.69447 12.6736 9.00696 12.1042 8.43752C11.5347 7.86808 10.8472 7.58335 10.0417 7.58335C9.22222 7.58335 8.53111 7.86808 7.96833 8.43752C7.40555 9.00696 7.12444 9.69447 7.125 10.5C7.125 11.3056 7.40611 11.9931 7.96833 12.5625C8.53055 13.132 9.22166 13.4167 10.0417 13.4167Z"
                    fill="white"
                  />
                </svg>
                Settings
              </Link>
              <div
                className="collapse sidebar_submenu"
                id="settings-collapse"
                data-bs-parent="#sidemenu"
              >
                <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <li>
                    <NavLink
                      to="/change-password"
                      className="link-body-emphasis d-inline-flex text-decoration-none rounded close_overlay"
                    >
                      Change Password
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>

            <li className="nav-item">
              <Link
                className="nav-link btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#user-collapse"
                aria-expanded="false"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                >
                  <path
                    d="M9.5 19C4.25315 19 0 14.7469 0 9.5C0 4.25315 4.25315 0 9.5 0C14.7469 0 19 4.25315 19 9.5C19 14.7469 14.7469 19 9.5 19ZM9.5 6.65H5.7V8.55H14.25L9.5 3.8V6.65ZM4.75 10.45L9.5 15.2V12.35H13.3V10.45H4.75Z"
                    fill="white"
                  />
                </svg>
                Profit Analysis
              </Link>
              <div
                className="collapse sidebar_submenu"
                id="user-collapse"
                data-bs-parent="#sidemenu"
              >
                <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <li>
                    <NavLink
                      to="/profit-list"
                      className="link-body-emphasis d-inline-flex text-decoration-none rounded close_overlay"
                    >
                      Paraswap
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#settings-collapseone"
                aria-expanded="false"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M3.77661 4.27661C3.77661 3.61357 4.04 2.97769 4.50884 2.50884C4.97769 2.04 5.61357 1.77661 6.27661 1.77661C6.93965 1.77661 7.57554 2.04 8.04438 2.50884C8.51322 2.97769 8.77661 3.61357 8.77661 4.27661C8.77661 4.93965 8.51322 5.57554 8.04438 6.04438C7.57554 6.51322 6.93965 6.77661 6.27661 6.77661C5.61357 6.77661 4.97769 6.51322 4.50884 6.04438C4.04 5.57554 3.77661 4.93965 3.77661 4.27661ZM12.2504 6.25661L12.3029 6.29661C12.8332 6.68974 13.4976 6.85713 14.1509 6.76225C14.8042 6.66737 15.3935 6.31791 15.7901 5.79015C16.1867 5.2624 16.3585 4.59918 16.268 3.94524C16.1774 3.2913 15.8318 2.69973 15.3067 2.29963C14.7816 1.89953 14.1195 1.72338 13.465 1.80963C12.8104 1.89588 12.2166 2.23753 11.8131 2.76C11.4095 3.28248 11.229 3.94338 11.3109 4.59846C11.3928 5.25353 11.7306 5.84962 12.2504 6.25661ZM7.86161 8.02661C8.01861 7.72932 8.23397 7.46674 8.49479 7.2546C8.75562 7.04246 9.05655 6.8851 9.3796 6.79195C9.70264 6.69879 10.0412 6.67176 10.3749 6.71245C10.7086 6.75315 11.0307 6.86074 11.3219 7.02879C11.6131 7.19685 11.8674 7.42191 12.0696 7.69051C12.2718 7.95912 12.4178 8.26575 12.4987 8.59206C12.5797 8.91837 12.594 9.25766 12.5408 9.58963C12.4876 9.9216 12.368 10.2394 12.1891 10.5241C11.845 11.0718 11.302 11.4648 10.6743 11.6205C10.0465 11.7763 9.38284 11.6826 8.82265 11.3593C8.26245 11.036 7.84936 10.5082 7.67015 9.88675C7.49095 9.26528 7.55957 8.59855 7.86161 8.02661ZM3.15161 8.02661H6.48911C6.26695 8.66106 6.21865 9.3434 6.34921 10.0028C6.47978 10.6622 6.78445 11.2747 7.23161 11.7766H6.90161C6.25716 11.7765 5.62842 11.9756 5.10147 12.3466C4.57451 12.7176 4.17508 13.2424 3.95786 13.8491C3.53828 13.6806 3.14542 13.4519 2.79161 13.1704C1.85161 12.4141 1.27661 11.2966 1.27661 9.90161C1.27661 9.40433 1.47416 8.92742 1.82579 8.57579C2.17742 8.22415 2.65433 8.02661 3.15161 8.02661ZM13.1516 11.7766C13.7959 11.7766 14.4244 11.9757 14.9512 12.3467C15.4779 12.7177 15.8771 13.2425 16.0941 13.8491C16.5191 13.6754 16.9129 13.4491 17.2616 13.1704C18.2016 12.4141 18.7766 11.2966 18.7766 9.90161C18.7766 9.40433 18.5791 8.92742 18.2274 8.57579C17.8758 8.22415 17.3989 8.02661 16.9016 8.02661H13.5641C13.7016 8.41786 13.7766 8.83911 13.7766 9.27661C13.7778 10.1993 13.4376 11.0897 12.8216 11.7766H13.1516ZM14.8854 14.1866C14.9766 14.4066 15.0266 14.6491 15.0266 14.9016C15.0266 16.2966 14.4529 17.4141 13.5116 18.1704C12.5854 18.9141 11.3429 19.2766 10.0266 19.2766C8.71036 19.2766 7.46786 18.9141 6.54161 18.1704C5.60161 17.4141 5.02661 16.2966 5.02661 14.9016C5.02595 14.6552 5.074 14.4111 5.16799 14.1833C5.26199 13.9555 5.40007 13.7486 5.57432 13.5743C5.74856 13.4001 5.95552 13.262 6.1833 13.168C6.41108 13.074 6.6552 13.026 6.90161 13.0266H13.1516C13.523 13.0265 13.886 13.1367 14.1947 13.3432C14.5034 13.5498 14.7437 13.8433 14.8854 14.1866Z"
                    fill="white"
                  />
                </svg>
                Pair Lists
              </Link>
              <div
                className="collapse sidebar_submenu"
                id="settings-collapseone"
                data-bs-parent="#sidemenu"
              >
                <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <li>
                    <NavLink
                      to="/pair-list"
                      className="link-body-emphasis d-inline-flex text-decoration-none rounded close_overlay"
                    >
                      Pairs
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>

            <li className="nav-item">
              <Link
                className="nav-link btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#transaction-collapseone"
                aria-expanded="false"
              >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="17"
                    viewBox="0 0 512 512"
                  >
                    <path d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" />
                  </svg>
                Transactions
              </Link>
              <div
                className="collapse sidebar_submenu"
                id="transaction-collapseone"
                data-bs-parent="#sidemenu"
              >
                <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <li>
                    <NavLink
                      to="/transaction-history"
                      className="link-body-emphasis d-inline-flex text-decoration-none rounded close_overlay"
                    >
                      Transaction history
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            <li className="nav-item">
                <Link
                  className="nav-link btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#token-collapse"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="19"
                    viewBox="0 0 512 512"
                  >
                    <path d="M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3c-.3-.1-.5-.2-.8-.3c-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-21.4 21.4-47.4 38.1-76.3 48.6zM256 91.9c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0 0 0c-2.2-.7-4.3-1.5-6.4-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1V304c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V112c0-11.1-9-20.1-20.1-20.1zM48 352H64c19.5 25.9 44 47.7 72.2 64H64v32H256 448V416H375.8c28.2-16.3 52.8-38.1 72.2-64h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z" />
                  </svg>
                  Token
                </Link>
                <div
                  className="collapse sidebar_submenu"
                  id="token-collapse"
                  data-bs-parent="#sidemenu"
                >
                  <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                    <li>
                      <NavLink
                        to="/token-management"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded close_overlay"
                      >
                        Token Management
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
          </ul>

        </div>
      </div>
    </>
  );
}
